import App from './index';

export {getStaticProps} from '@amplify/abflag';

// Required for dynamic routes in Next.js
export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}

export default App;
